export default {
  syncForm (state, form) {
    state.form = form
  },

  updateField (state, {field, value}) {
    state.form[field] = value
    localStorage.setItem('checkoutFormData', JSON.stringify(state.form))
  },

  toggleLoading (state, status) {
    state.loading = status
  },
}
